import { ButtonPrimeReact, PrimeReactModal } from "@finanedi.es/storybook"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { UpdateInvitacionesAsesoriaCommandProps } from "api/Commands/UpdateInvitacionesAsesoriaCommand"
import { AsesoriaGetEmpresaActivaUsuarioDtoProps } from "api/DTOs/AsesoriaGetEmpresaActivaUsuarioDto"
import { ESTADO_INVITACION_ASESORIA } from "api/Types/EstadoInvitacionAsesoria"
import { MODAL_STYLES } from "constants/primereactStyles"
import { Message } from "primereact/message"
import { useTranslation } from "react-i18next"
import { convertImgBase64 } from "utils/convertBase64"
import { ManageModalAsesoriaActivaProps } from "."

export interface ModalCierreCargandoProps {
  isOpen: boolean
  onDeleteAsesoria: ({
    invitaciones,
  }: UpdateInvitacionesAsesoriaCommandProps) => void
  onCloseModal: () => void
  setShowModalInvitacionesAsesoria: (value: boolean) => void
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  asesoriaActiva: AsesoriaGetEmpresaActivaUsuarioDtoProps | any
  setShowModalNoHayInvitacionesAsesoria: (value: boolean) => void
  manageModalAsesoriaActiva: ManageModalAsesoriaActivaProps
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setManageModalAsesoriaActiva: $TSMigrationFixMe
  totalInvitacionesAsesoria?: number
}

export const ModalAsesoriaActiva = ({
  isOpen = false,
  onDeleteAsesoria,
  onCloseModal,
  setShowModalInvitacionesAsesoria,
  asesoriaActiva,
  setShowModalNoHayInvitacionesAsesoria,
  manageModalAsesoriaActiva,
  setManageModalAsesoriaActiva,
  totalInvitacionesAsesoria,
}: ModalCierreCargandoProps) => {
  const { t } = useTranslation()

  return (
    <PrimeReactModal
      visible={isOpen}
      className='tw-w-128 tw-rounded-lg tw-py-5 tw-px-6 tw-bg-white'
      baseZIndex={20}
      ptContext={MODAL_STYLES}
      closable={false}
      keepInViewport={false}
      header={
        <div className='tw-flex tw-justify-between tw-items-center tw-mb-6'>
          <p className='tw-text-2xl tw-font-medium tw-text-primary tw-m-0'>
            {t("crear.asesoria.modal.titleAsesoria")}
          </p>
          <ButtonPrimeReact
            className='!tw-p-0 !tw-min-w-0 !tw-bg-white !tw-border-none !tw-text-black'
            onClick={() => {
              onCloseModal()
            }}
          >
            <FontAwesomeIcon
              icon={["fal", "xmark"]}
              className='tw-w-5 tw-h-5'
            />
          </ButtonPrimeReact>
        </div>
      }
      footer={
        <div
          key='Actions'
          className='tw-flex tw-flex-row tw-justify-end tw-gap-3 tw-mt-3'
        >
          <ButtonPrimeReact
            label={`${t("crear.asesoria.modal.closeButton")}`}
            className='tw-h-12 !tw-bg-inherit !tw-border-none !tw-text-text tw-items-center'
            onClick={() => {
              onCloseModal()
            }}
          />
          <ButtonPrimeReact
            id='confirmModal'
            label={`${t("crear.asesoria.modal.saveButton")}`}
            className='tw-h-12 !tw-bg-primary !tw-border-none tw-text-simple-10 tw-items-center'
            onClick={() => {
              manageModalAsesoriaActiva.deleteAsesoria &&
                onDeleteAsesoria({
                  invitaciones: [
                    {
                      id: asesoriaActiva?.invitacionId,
                      estadoInvitacion: ESTADO_INVITACION_ASESORIA.RECHAZADA,
                    },
                  ],
                })
              onCloseModal()
            }}
          />
        </div>
      }
    >
      <div>
        <div className='tw-flex tw-justify-between tw-pb-3 tw-text-base'>
          <span className='tw-font-medium'>
            {t("crear.asesoria.modal.currentAsesoría")}
          </span>
          <span
            className='tw-text-info tw-cursor-pointer'
            onClick={() => {
              totalInvitacionesAsesoria && totalInvitacionesAsesoria > 0
                ? setShowModalInvitacionesAsesoria(true)
                : setShowModalNoHayInvitacionesAsesoria(true)
            }}
          >
            {t("crear.asesoria.modal.receivedRequests")}
          </span>
        </div>
        {manageModalAsesoriaActiva.deleteAsesoria && (
          <Message
            className='tw-w-full tw-pl-4 tw-mb-4 !tw-border !tw-border-warning !tw-bg-warning-10 !tw-text-warning'
            severity='warn'
            text={`${t("crear.asesoria.modal.warningMessage")}`}
          />
        )}
        <div className='tw-bg-background tw-p-2'>
          <div className='tw-bg-simple-10 tw-w-full tw-px-4 tw-py-3 tw-rounded tw-shadow tw-grid tw-grid-cols-5'>
            <div className='tw-flex tw-items-center tw-justify-center tw-col-span-1 tw-mr-3'>
              {asesoriaActiva?.logo?.base64 ? (
                <img
                  className='tw-h-10 tw-object-contain'
                  alt='logoAsesoriaInvitacion'
                  src={convertImgBase64({
                    base64: asesoriaActiva.logo?.base64,
                    mediaType: asesoriaActiva.logo?.mediaType,
                  })}
                />
              ) : (
                <FontAwesomeIcon
                  icon={["fal", "handshake"]}
                  className='tw-self-center tw-w-5 tw-h-5'
                />
              )}
            </div>
            <div className='tw-flex-col tw-text-left tw-col-span-3'>
              <p className='tw-mb-1 tw-h-5 tw-font-medium tw-max-w-56 tw-truncate'>
                {asesoriaActiva?.razonSocial}
              </p>
              <p className='tw-mb-0 tw-text-text tw-text-xs'>
                {asesoriaActiva?.provinciaRegistroMercantil}
              </p>
            </div>
            <div className='tw-flex tw-col-span-1'>
              <ButtonPrimeReact
                className={`!tw-border-0 !tw-py-2 !tw-bg-white ${
                  manageModalAsesoriaActiva.deleteAsesoria
                    ? "!tw-text-text-hyperlinks"
                    : "!tw-text-danger"
                }  !tw-px-4`}
                onClick={() =>
                  setManageModalAsesoriaActiva(
                    (prev: ManageModalAsesoriaActivaProps) => ({
                      ...prev,
                      deleteAsesoria: !prev.deleteAsesoria,
                    })
                  )
                }
              >
                {manageModalAsesoriaActiva.deleteAsesoria
                  ? t("crear.asesoria.modal.undoButton")
                  : t("crear.asesoria.modal.deleteButton")}
              </ButtonPrimeReact>
            </div>
          </div>
        </div>
      </div>
    </PrimeReactModal>
  )
}
